export const heroSlides = [
  {
    id: "1002",
    tag: "年度星际科幻巨制",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20deep%20space%20with%20a%20lone%20spaceship%20gliding%20toward%20a%20giant%20glowing%20blue%20planet%20surrounded%20by%20rings%20and%20nebula%20clouds%2C%20deep%20navy%20and%20cyan%20tones%2C%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-91-01&orientation=landscape",
  },
  {
    id: "1010",
    tag: "古装权谋口碑之作",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20misty%20ancient%20Chinese%20mountains%20with%20a%20solitary%20palace%20and%20a%20general%20silhouette%20on%20a%20ridge%20at%20dusk%2C%20deep%20blue%20and%20ink%20black%20tones%2C%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-91-02&orientation=landscape",
  },
  {
    id: "1020",
    tag: "热血动漫人气之作",
    image: "https://readdy.ai/api/search-image?query=Epic%20anime%20style%20wide%20shot%20of%20a%20young%20traveler%20on%20a%20floating%20island%20facing%20a%20vast%20colorful%20star%20filled%20sky%20with%20shooting%20stars%2C%20deep%20blue%20and%20cyan%20tones%2C%20vibrant%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-91-03&orientation=landscape",
  },
  {
    id: "1014",
    tag: "悬疑烧脑必看",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20small%20town%20road%20disappearing%20into%20thick%20night%20fog%20with%20dim%20street%20lamps%20and%20pine%20silhouettes%2C%20deep%20blue%20and%20grey%20tones%2C%20eerie%20moody%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-91-04&orientation=landscape",
  },
  {
    id: "1007",
    tag: "口碑科幻剧集",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20fog%20covered%20outpost%20at%20the%20edge%20of%20a%20dark%20forest%20with%20searchlights%20cutting%20through%20mist%20at%20night%2C%20deep%20teal%20and%20navy%20tones%2C%20ominous%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-91-05&orientation=landscape",
  },
];